import {
  Debounce,
  SectionElement,
  SectionRenderer,
  Theme,
  defineElement,
  globalOn,
  liquidValue,
  on,
  onClick,
  query,
  wait
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __commonJS,
  __decorateClass,
  __toESM
} from "./chunk-RGTSXKO2.js";

// node_modules/rematrix/dist/rematrix.js
var require_rematrix = __commonJS({
  "node_modules/rematrix/dist/rematrix.js"(exports, module) {
    (function(global, factory) {
      typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : factory(global.Rematrix = {});
    })(exports, function(exports2) {
      "use strict";
      function format(source) {
        if (source.constructor !== Array) {
          throw new TypeError("Expected array.");
        }
        if (source.length === 16) {
          return source;
        }
        if (source.length === 6) {
          var matrix = identity();
          matrix[0] = source[0];
          matrix[1] = source[1];
          matrix[4] = source[2];
          matrix[5] = source[3];
          matrix[12] = source[4];
          matrix[13] = source[5];
          return matrix;
        }
        throw new RangeError("Expected array with either 6 or 16 values.");
      }
      function identity() {
        var matrix = [];
        for (var i = 0; i < 16; i++) {
          i % 5 == 0 ? matrix.push(1) : matrix.push(0);
        }
        return matrix;
      }
      function inverse(source) {
        var m = format(source);
        var s0 = m[0] * m[5] - m[4] * m[1];
        var s1 = m[0] * m[6] - m[4] * m[2];
        var s2 = m[0] * m[7] - m[4] * m[3];
        var s3 = m[1] * m[6] - m[5] * m[2];
        var s4 = m[1] * m[7] - m[5] * m[3];
        var s5 = m[2] * m[7] - m[6] * m[3];
        var c5 = m[10] * m[15] - m[14] * m[11];
        var c4 = m[9] * m[15] - m[13] * m[11];
        var c3 = m[9] * m[14] - m[13] * m[10];
        var c2 = m[8] * m[15] - m[12] * m[11];
        var c1 = m[8] * m[14] - m[12] * m[10];
        var c0 = m[8] * m[13] - m[12] * m[9];
        var determinant = 1 / (s0 * c5 - s1 * c4 + s2 * c3 + s3 * c2 - s4 * c1 + s5 * c0);
        if (isNaN(determinant) || determinant === Infinity) {
          throw new Error("Inverse determinant attempted to divide by zero.");
        }
        return [
          (m[5] * c5 - m[6] * c4 + m[7] * c3) * determinant,
          (-m[1] * c5 + m[2] * c4 - m[3] * c3) * determinant,
          (m[13] * s5 - m[14] * s4 + m[15] * s3) * determinant,
          (-m[9] * s5 + m[10] * s4 - m[11] * s3) * determinant,
          (-m[4] * c5 + m[6] * c2 - m[7] * c1) * determinant,
          (m[0] * c5 - m[2] * c2 + m[3] * c1) * determinant,
          (-m[12] * s5 + m[14] * s2 - m[15] * s1) * determinant,
          (m[8] * s5 - m[10] * s2 + m[11] * s1) * determinant,
          (m[4] * c4 - m[5] * c2 + m[7] * c0) * determinant,
          (-m[0] * c4 + m[1] * c2 - m[3] * c0) * determinant,
          (m[12] * s4 - m[13] * s2 + m[15] * s0) * determinant,
          (-m[8] * s4 + m[9] * s2 - m[11] * s0) * determinant,
          (-m[4] * c3 + m[5] * c1 - m[6] * c0) * determinant,
          (m[0] * c3 - m[1] * c1 + m[2] * c0) * determinant,
          (-m[12] * s3 + m[13] * s1 - m[14] * s0) * determinant,
          (m[8] * s3 - m[9] * s1 + m[10] * s0) * determinant
        ];
      }
      function multiply(m, x) {
        var fm = format(m);
        var fx = format(x);
        var product = [];
        for (var i = 0; i < 4; i++) {
          var row = [fm[i], fm[i + 4], fm[i + 8], fm[i + 12]];
          for (var j = 0; j < 4; j++) {
            var k = j * 4;
            var col = [fx[k], fx[k + 1], fx[k + 2], fx[k + 3]];
            var result = row[0] * col[0] + row[1] * col[1] + row[2] * col[2] + row[3] * col[3];
            product[i + k] = result;
          }
        }
        return product;
      }
      function parse(source) {
        if (typeof source === "string") {
          var match = source.match(/matrix(3d)?\(([^)]+)\)/);
          if (match) {
            var raw = match[2].split(", ").map(function(value) {
              return parseFloat(value);
            });
            return format(raw);
          }
        }
        return identity();
      }
      function rotateX(angle) {
        var theta = Math.PI / 180 * angle;
        var matrix = identity();
        matrix[5] = matrix[10] = Math.cos(theta);
        matrix[6] = matrix[9] = Math.sin(theta);
        matrix[9] *= -1;
        return matrix;
      }
      function rotateY(angle) {
        var theta = Math.PI / 180 * angle;
        var matrix = identity();
        matrix[0] = matrix[10] = Math.cos(theta);
        matrix[2] = matrix[8] = Math.sin(theta);
        matrix[2] *= -1;
        return matrix;
      }
      function rotateZ(angle) {
        var theta = Math.PI / 180 * angle;
        var matrix = identity();
        matrix[0] = matrix[5] = Math.cos(theta);
        matrix[1] = matrix[4] = Math.sin(theta);
        matrix[4] *= -1;
        return matrix;
      }
      function scale(scalar, scalarY) {
        var matrix = identity();
        matrix[0] = scalar;
        matrix[5] = scalarY || scalar;
        return matrix;
      }
      function scaleX(scalar) {
        var matrix = identity();
        matrix[0] = scalar;
        return matrix;
      }
      function scaleY(scalar) {
        var matrix = identity();
        matrix[5] = scalar;
        return matrix;
      }
      function scaleZ(scalar) {
        var matrix = identity();
        matrix[10] = scalar;
        return matrix;
      }
      function skew(angleX, angleY) {
        var thetaX = Math.PI / 180 * angleX;
        var matrix = identity();
        matrix[4] = Math.tan(thetaX);
        if (angleY) {
          var thetaY = Math.PI / 180 * angleY;
          matrix[1] = Math.tan(thetaY);
        }
        return matrix;
      }
      function skewX(angle) {
        var theta = Math.PI / 180 * angle;
        var matrix = identity();
        matrix[4] = Math.tan(theta);
        return matrix;
      }
      function skewY(angle) {
        var theta = Math.PI / 180 * angle;
        var matrix = identity();
        matrix[1] = Math.tan(theta);
        return matrix;
      }
      function translate(distanceX, distanceY) {
        var matrix = identity();
        matrix[12] = distanceX;
        if (distanceY) {
          matrix[13] = distanceY;
        }
        return matrix;
      }
      function translateX(distance) {
        var matrix = identity();
        matrix[12] = distance;
        return matrix;
      }
      function translateY(distance) {
        var matrix = identity();
        matrix[13] = distance;
        return matrix;
      }
      function translateZ(distance) {
        var matrix = identity();
        matrix[14] = distance;
        return matrix;
      }
      exports2.format = format;
      exports2.identity = identity;
      exports2.inverse = inverse;
      exports2.multiply = multiply;
      exports2.parse = parse;
      exports2.rotateX = rotateX;
      exports2.rotateY = rotateY;
      exports2.rotateZ = rotateZ;
      exports2.scale = scale;
      exports2.scaleX = scaleX;
      exports2.scaleY = scaleY;
      exports2.scaleZ = scaleZ;
      exports2.skew = skew;
      exports2.skewX = skewX;
      exports2.skewY = skewY;
      exports2.translate = translate;
      exports2.translateX = translateX;
      exports2.translateY = translateY;
      exports2.translateZ = translateZ;
      Object.defineProperty(exports2, "__esModule", { value: true });
    });
  }
});

// node_modules/flipping/lib/constants.js
var require_constants = __commonJS({
  "node_modules/flipping/lib/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FOLLOW_ATTR = "data-flip-follow";
    exports.KEY_ATTR = "data-flip-key";
    exports.STATE_ATTR = "data-flip-state";
    exports.NO_DELTA = { top: 0, left: 0, width: 1, height: 1 };
  }
});

// node_modules/flipping/lib/utils.js
var require_utils = __commonJS({
  "node_modules/flipping/lib/utils.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Rematrix = require_rematrix();
    var constants_1 = require_constants();
    function mapValues(collection, iteratee) {
      var result = {};
      Object.keys(collection).forEach(function(key) {
        result[key] = iteratee(collection[key], key, collection);
      });
      return result;
    }
    exports.mapValues = mapValues;
    function mapTwoValues(a, b, iteratee) {
      var result = {};
      Object.keys(a || {}).forEach(function(key) {
        result[key] = iteratee(a[key], b[key], key);
      });
      return result;
    }
    exports.mapTwoValues = mapTwoValues;
    function matrixTranslate(x, y) {
      return Rematrix.translate(x, y).join(",");
    }
    exports.matrixTranslate = matrixTranslate;
    function matrixScale(x, y) {
      return Rematrix.scale(x, y).join(",");
    }
    exports.matrixScale = matrixScale;
    function matrixMultiply() {
      var matrices = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        matrices[_i] = arguments[_i];
      }
      return matrices.filter(function(a) {
        return !!a;
      }).reduce(Rematrix.multiply).join(",");
    }
    exports.matrixMultiply = matrixMultiply;
    function styleValue(prop, value) {
      if (["height", "width", "top", "left"].indexOf(prop) !== -1 && typeof value === "number") {
        return value + "px";
      }
      return value;
    }
    exports.styleValue = styleValue;
    function getStaggerDelay(index, stagger) {
      return typeof stagger === "function" ? stagger(index) : (stagger || 0) * index;
    }
    exports.getStaggerDelay = getStaggerDelay;
    exports.identity = function(a) {
      return a;
    };
    exports.noop = function() {
    };
    exports.rect = function(element) {
      var _a2 = element.getBoundingClientRect(), top = _a2.top, left = _a2.left, width = _a2.width, height = _a2.height;
      return {
        top,
        left,
        width,
        height,
        get transform() {
          return getComputedStyle(element).transform || void 0;
        }
      };
    };
    function isVisible(element) {
      var _a2 = exports.rect(element), width = _a2.width, height = _a2.height;
      return !(width === 0 && height === 0);
    }
    exports.isVisible = isVisible;
    function getDelta(a, b) {
      if (!a) {
        return constants_1.NO_DELTA;
      }
      if (!a.height) {
        return a;
      }
      if (!b.height) {
        return b;
      }
      return {
        top: a.top - b.top,
        left: a.left - b.left,
        width: a.width / b.width,
        height: a.height / b.height
      };
    }
    exports.getDelta = getDelta;
    exports.deltaChanged = function(delta) {
      return !!delta.top || !!delta.left || delta.width !== 1 || delta.height !== 1;
    };
    exports.boundsChanged = function(a, b) {
      return !!(a.top - b.top || a.left - b.left || a.width - b.width || a.height - b.height);
    };
    function mitt() {
      var all = {};
      var wild = [];
      return {
        /**
         * Register an event handler for the given type.
         *
         * @param  {String} type	Type of event to listen for, or `"*"` for all events
         * @param  {Function} handler Function to call in response to given event
         * @memberOf mitt
         */
        on: function(type, handler) {
          if (type === "*") {
            wild.push(handler);
          } else {
            (all[type] || (all[type] = [])).push(handler);
          }
        },
        /**
         * Remove an event handler for the given type.
         *
         * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
         * @param  {Function} handler Handler function to remove
         * @memberOf mitt
         */
        off: function(type, handler) {
          if (type === "*") {
            wild.splice(wild.indexOf(handler) >>> 0, 1);
          } else if (all[type]) {
            all[type].splice(all[type].indexOf(handler) >>> 0, 1);
          }
        },
        /**
         * Invoke all handlers for the given type.
         * If present, `"*"` handlers are invoked after type-matched handlers.
         *
         * @param {String} type  The event type to invoke
         * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
         * @memberOf mitt
         */
        emit: function(type, evt) {
          (all[type] || []).slice().map(function(handler) {
            handler(evt);
          });
          wild.slice().map(function(handler) {
            handler(type, evt);
          });
        }
      };
    }
    exports.mitt = mitt;
  }
});

// node_modules/flipping/lib/plugins/mirror.js
var require_mirror = __commonJS({
  "node_modules/flipping/lib/plugins/mirror.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
      }
      return t;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    function mirrorPlugin(states, event) {
      if (event !== "flip") {
        return states;
      }
      var nextStates = {};
      Object.keys(states).forEach(function(key) {
        var state = states[key];
        var element = state.element || state.previous && state.previous.element;
        if (element) {
          if (element.hasAttribute("data-flip-follow")) {
            var followKey = element.getAttribute("data-flip-follow");
            if (followKey && states[followKey]) {
              nextStates[key] = __assign({}, state, { delta: __assign({ left: 0, top: 0 }, states[followKey].delta, { width: 1, height: 1 }) });
            } else if (state.type === "ENTER" || state.type === "LEAVE") {
              var candidateElement = element.nextElementSibling;
              while (candidateElement && (!candidateElement.hasAttribute("data-flip-key") || states[candidateElement.getAttribute("data-flip-key")].type !== "MOVE")) {
                candidateElement = candidateElement.nextElementSibling;
              }
              if (candidateElement) {
                var candidateDelta = states[candidateElement.getAttribute("data-flip-key")].delta;
                nextStates[key] = __assign({}, state, { delta: {
                  left: candidateDelta.left,
                  top: candidateDelta.top,
                  width: 1,
                  height: 1
                } });
              }
            }
          }
        }
      });
      return Object.assign(states, nextStates);
    }
    exports.default = mirrorPlugin;
  }
});

// node_modules/flipping/lib/plugins/radius.js
var require_radius = __commonJS({
  "node_modules/flipping/lib/plugins/radius.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function radiusPlugin(states, event) {
      if (event === "read") {
        Object.keys(states).forEach(function(key) {
          var state = states[key];
          var element = state.element;
          if (!element) {
            return;
          }
          state.data.radius = getComputedStyle ? getComputedStyle(element).borderRadius || "0" : "0";
        });
      }
      return states;
    }
    exports.default = radiusPlugin;
  }
});

// node_modules/flipping/lib/Flipping.js
var require_Flipping = __commonJS({
  "node_modules/flipping/lib/Flipping.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
      }
      return t;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    var utils_1 = require_utils();
    var constants_1 = require_constants();
    var mirror_1 = require_mirror();
    var radius_1 = require_radius();
    var active = function() {
      return true;
    };
    var identity = function(a) {
      return a;
    };
    var flipDatasetMap = {
      flipKey: ["key", identity],
      flipNoScale: ["noScale", function() {
        return true;
      }]
    };
    var getFlipData = function(element) {
      if (!("dataset" in element)) {
        return {};
      }
      var dataset = element.dataset;
      var data = {};
      Object.keys(dataset).forEach(function(key) {
        if (flipDatasetMap[key]) {
          var _a2 = flipDatasetMap[key], flipKey = _a2[0], project = _a2[1];
          data[flipKey] = project(dataset[key]);
        } else if (key.indexOf("flip") === 0) {
          data[key[4].toLowerCase() + key.slice(5)] = dataset[key];
        }
      });
      return data;
    };
    var createSelector = function(selector, attribute) {
      if (attribute === void 0) {
        attribute = constants_1.KEY_ATTR;
      }
      if (typeof selector === "string") {
        return function(parentElement) {
          var elements = parentElement.querySelectorAll(selector);
          var visibleElements = {};
          var result = [];
          elements.forEach(function(element) {
            if (!utils_1.isVisible(element)) {
              return;
            }
            var key = element.getAttribute(attribute);
            if (!key) {
              return;
            }
            visibleElements[key] = element;
            result.push(element);
          });
          return result;
        };
      }
      return selector;
    };
    var Flipping2 = (
      /** @class */
      function() {
        function Flipping3(options) {
          if (options === void 0) {
            options = {};
          }
          this.attribute = options.attribute || constants_1.KEY_ATTR;
          this.selector = createSelector(options.selector || "[" + this.attribute + "]", this.attribute);
          this.active = options.active || active;
          this.activeSelector = options.activeSelector || utils_1.isVisible;
          this.getBounds = options.getBounds || utils_1.rect;
          this.getDelta = options.getDelta || utils_1.getDelta;
          this.parentElement = options.parent || document.documentElement;
          this.plugins = options.plugins || [mirror_1.default, radius_1.default];
          this.emitter = utils_1.mitt();
          if (options.onRead) {
            this.on("read", options.onRead);
          }
          if (options.onFlip) {
            this.on("flip", options.onFlip);
          }
          if (options.onEnter) {
            this.on("enter", options.onEnter);
          }
          if (options.onLeave) {
            this.on("leave", options.onLeave);
          }
          this.states = {};
        }
        Flipping3.prototype.getRelativeBounds = function(parentBounds, childBounds) {
          return __assign({}, childBounds, { top: childBounds.top - parentBounds.top, left: childBounds.left - parentBounds.left });
        };
        Flipping3.prototype.selectActive = function(parentElement) {
          var _this = this;
          var elements = this.selector(parentElement);
          var activeElements = {};
          var result = [];
          elements.forEach(function(element) {
            if (!_this.activeSelector(element)) {
              return;
            }
            var key = element.getAttribute(_this.attribute);
            if (!key) {
              return;
            }
            activeElements[key] = element;
            result.push(element);
          });
          return result;
        };
        Flipping3.prototype.findParent = function(element, parent) {
          if (parent === void 0) {
            parent = this.parentElement;
          }
          var parentKey = element.getAttribute("data-flip-parent");
          var currentParent = element.parentElement;
          if (!parentKey) {
            while (currentParent && !currentParent.hasAttribute(this.attribute)) {
              currentParent = currentParent.parentElement;
            }
          } else {
            while (currentParent && currentParent.getAttribute(this.attribute) !== parentKey) {
              currentParent = currentParent.parentElement;
            }
          }
          return currentParent || parent;
        };
        Flipping3.prototype.dispatch = function(event, stateMap) {
          var finalStateMap = this.plugins.reduce(function(intermediateStateMap, plugin) {
            return plugin(intermediateStateMap, event);
          }, stateMap);
          this.emitter.emit(event, finalStateMap);
        };
        Flipping3.prototype.on = function(event, listener) {
          this.emitter.on(event, listener);
        };
        Flipping3.prototype.onFlip = function() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          var key;
          var listener;
          if (args.length === 2) {
            key = args[0], listener = args[1];
          } else {
            listener = args[0];
          }
          this.emitter.on("flip", key ? function(stateMap) {
            var state = stateMap[key];
            if (state) {
              listener(state);
            }
          } : listener);
        };
        Flipping3.prototype.read = function(options) {
          if (options === void 0) {
            options = {};
          }
          this.flip(__assign({}, options, { readOnly: true }));
        };
        Flipping3.prototype.flip = function(options) {
          var _this = this;
          if (options === void 0) {
            options = {};
          }
          var parentElement = options.parent || this.parentElement;
          var elements = this.selectActive(parentElement);
          var fullState = {};
          elements.forEach(function(element, index) {
            var key = element.getAttribute(_this.attribute);
            if (!key) {
              return;
            }
            var data = getFlipData(element);
            var childParent = _this.findParent(element, parentElement);
            var childParentKey = childParent.getAttribute(_this.attribute);
            var childParentState = childParentKey ? fullState[childParentKey] : void 0;
            var parentBounds = _this.getBounds(childParent);
            var previous = _this.states[key];
            var isPresent = previous && previous.type !== "LEAVE";
            var bounds = _this.getRelativeBounds(parentBounds, _this.getBounds(element));
            var delta = isPresent && previous && previous.bounds ? _this.getDelta(previous.bounds, bounds) : void 0;
            var newState = {
              type: isPresent ? "MOVE" : "ENTER",
              key,
              element,
              bounds,
              delta,
              start: Date.now(),
              animation: isPresent ? previous.animation : void 0,
              index,
              previous: previous ? {
                type: previous.type,
                bounds: previous.bounds,
                animation: previous.animation,
                element: previous.element,
                data: previous.data
              } : void 0,
              parent: childParentState,
              data
            };
            _this.states[key] = fullState[key] = newState;
          });
          if (options.readOnly) {
            return this.dispatch("read", fullState);
          }
          Object.keys(this.states).forEach(function(key, index) {
            if (fullState[key]) {
              return;
            }
            var prevState = _this.states[key];
            _this.states[key] = fullState[key] = {
              type: "LEAVE",
              key,
              element: void 0,
              bounds: void 0,
              start: Date.now(),
              animation: void 0,
              delta: void 0,
              index,
              parent: void 0,
              previous: {
                type: prevState.type,
                bounds: prevState.bounds,
                animation: prevState.animation,
                element: prevState.element
              }
            };
          });
          return this.dispatch("flip", fullState);
        };
        Flipping3.prototype.setAnimation = function(key, animation) {
          this.states[key].animation = animation;
        };
        Flipping3.prototype.wrap = function(fn, options) {
          var _this = this;
          if (options === void 0) {
            options = {};
          }
          return function() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            _this.read(options);
            var result = fn.apply(null, args);
            _this.flip(options);
            return result;
          };
        };
        Flipping3.prototype.progress = function(key, fraction) {
          var delta = this.states[key].delta;
          if (!delta) {
            return;
          }
          return Flipping3.progress(delta, fraction);
        };
        Flipping3.progress = function(delta, fraction) {
          if (!delta) {
            return constants_1.NO_DELTA;
          }
          var invFraction = 1 - fraction;
          return {
            top: delta.top * invFraction,
            left: delta.left * invFraction,
            width: delta.width * invFraction,
            height: delta.height * invFraction
          };
        };
        Flipping3.rect = utils_1.rect;
        Flipping3.willScale = function(state) {
          return !!(state && state.element && !state.element.hasAttribute("data-noflip") && state.delta && (state.delta.width !== 1 || state.delta.height !== 1));
        };
        Flipping3.willMove = function(state) {
          if (!state || !state.delta) {
            return false;
          }
          return state && (state.delta.top !== 0 || state.delta.left !== 0);
        };
        return Flipping3;
      }()
    );
    exports.default = Flipping2;
  }
});

// node_modules/flipping/lib/index.js
var require_lib = __commonJS({
  "node_modules/flipping/lib/index.js"(exports, module) {
    "use strict";
    var Flipping_1 = require_Flipping();
    module.exports = Flipping_1.default;
  }
});

// node_modules/printd/index.js
var require_printd = __commonJS({
  "node_modules/printd/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Printd = exports.createIFrame = exports.createLinkStyle = exports.createStyle = void 0;
    var URL_LONG = /^(((http[s]?)|file):)?(\/\/)+([0-9a-zA-Z-_.=?&].+)$/;
    var URL_SHORT = /^((\.|\.\.)?\/)([0-9a-zA-Z-_.=?&]+\/)*([0-9a-zA-Z-_.=?&]+)$/;
    var isValidURL = function(str) {
      return URL_LONG.test(str) || URL_SHORT.test(str);
    };
    function createStyle(doc, cssText) {
      var style = doc.createElement("style");
      style.appendChild(doc.createTextNode(cssText));
      return style;
    }
    exports.createStyle = createStyle;
    function createLinkStyle(doc, url) {
      var style = doc.createElement("link");
      style.type = "text/css";
      style.rel = "stylesheet";
      style.href = url;
      return style;
    }
    exports.createLinkStyle = createLinkStyle;
    function createIFrame(parent) {
      var el = window.document.createElement("iframe");
      el.setAttribute("src", "about:blank");
      el.setAttribute("style", "visibility:hidden;width:0;height:0;position:absolute;z-index:-9999;bottom:0;");
      el.setAttribute("width", "0");
      el.setAttribute("height", "0");
      el.setAttribute("wmode", "opaque");
      parent.appendChild(el);
      return el;
    }
    exports.createIFrame = createIFrame;
    var DEFAULT_OPTIONS = {
      parent: window.document.body,
      headElements: [],
      bodyElements: []
    };
    var Printd2 = (
      /** @class */
      function() {
        function Printd3(options) {
          this.isLoading = false;
          this.hasEvents = false;
          this.opts = [DEFAULT_OPTIONS, options || {}].reduce(function(a, b) {
            Object.keys(b).forEach(function(k) {
              return a[k] = b[k];
            });
            return a;
          }, {});
          this.iframe = createIFrame(this.opts.parent);
        }
        Printd3.prototype.getIFrame = function() {
          return this.iframe;
        };
        Printd3.prototype.print = function(el, styles, scripts, callback) {
          if (this.isLoading)
            return;
          var _a2 = this.iframe, contentDocument = _a2.contentDocument, contentWindow = _a2.contentWindow;
          if (!contentDocument || !contentWindow)
            return;
          this.iframe.src = "about:blank";
          this.elCopy = el.cloneNode(true);
          if (!this.elCopy)
            return;
          this.isLoading = true;
          this.callback = callback;
          var doc = contentWindow.document;
          doc.open();
          doc.write('<!DOCTYPE html><html><head><meta charset="utf-8"></head><body></body></html>');
          this.addEvents();
          var _b2 = this.opts, headElements = _b2.headElements, bodyElements = _b2.bodyElements;
          if (Array.isArray(headElements)) {
            headElements.forEach(function(el2) {
              return doc.head.appendChild(el2);
            });
          }
          if (Array.isArray(bodyElements)) {
            bodyElements.forEach(function(el2) {
              return doc.body.appendChild(el2);
            });
          }
          if (Array.isArray(styles)) {
            styles.forEach(function(value) {
              if (value) {
                doc.head.appendChild(isValidURL(value) ? createLinkStyle(doc, value) : createStyle(doc, value));
              }
            });
          }
          doc.body.appendChild(this.elCopy);
          if (Array.isArray(scripts)) {
            scripts.forEach(function(value) {
              if (value) {
                var script = doc.createElement("script");
                if (isValidURL(value)) {
                  script.src = value;
                } else {
                  script.innerText = value;
                }
                doc.body.appendChild(script);
              }
            });
          }
          doc.close();
        };
        Printd3.prototype.printURL = function(url, callback) {
          if (this.isLoading)
            return;
          this.addEvents();
          this.isLoading = true;
          this.callback = callback;
          this.iframe.src = url;
        };
        Printd3.prototype.onBeforePrint = function(callback) {
          this.onbeforeprint = callback;
        };
        Printd3.prototype.onAfterPrint = function(callback) {
          this.onafterprint = callback;
        };
        Printd3.prototype.launchPrint = function(contentWindow) {
          if (!this.isLoading) {
            contentWindow.print();
          }
        };
        Printd3.prototype.addEvents = function() {
          var _this = this;
          if (!this.hasEvents) {
            this.hasEvents = true;
            this.iframe.addEventListener("load", function() {
              return _this.onLoad();
            }, false);
            var contentWindow = this.iframe.contentWindow;
            if (contentWindow) {
              if (this.onbeforeprint) {
                contentWindow.addEventListener("beforeprint", this.onbeforeprint);
              }
              if (this.onafterprint) {
                contentWindow.addEventListener("afterprint", this.onafterprint);
              }
            }
          }
        };
        Printd3.prototype.onLoad = function() {
          var _this = this;
          if (this.iframe) {
            this.isLoading = false;
            var _a2 = this.iframe, contentDocument = _a2.contentDocument, contentWindow_1 = _a2.contentWindow;
            if (!contentDocument || !contentWindow_1)
              return;
            if (typeof this.callback === "function") {
              this.callback({
                iframe: this.iframe,
                element: this.elCopy,
                launchPrint: function() {
                  return _this.launchPrint(contentWindow_1);
                }
              });
            } else {
              this.launchPrint(contentWindow_1);
            }
          }
        };
        return Printd3;
      }()
    );
    exports.Printd = Printd2;
    exports.default = Printd2;
  }
});

// src/sections/common-cart-drawer/common-cart-drawer.ts
var import_flipping = __toESM(require_lib());

// src/shared/Search.ts
var _Search = class {
  static search(_0) {
    return __async(this, arguments, function* (q, config = {}) {
      const { type, limit, limitScope, unavailableProducts, fields } = config;
      const url = new URL(_Search.API_URL, location.origin);
      url.searchParams.set("q", q);
      if (type) {
        url.searchParams.set("resources[type]", Array.isArray(type) ? type.join(",") : type);
      }
      if (limit) {
        url.searchParams.set("resources[limit]", limit.toString());
      }
      if (limitScope) {
        url.searchParams.set("resources[limit_scope]", limitScope);
      }
      if (unavailableProducts) {
        url.searchParams.set("resources[options][unavailable_products]", unavailableProducts);
      }
      if (fields) {
        url.searchParams.set("resources[options][fields]", Array.isArray(fields) ? fields.join(",") : fields);
      }
      return fetch(url.href).then((response) => response.json());
    });
  }
};
var Search = _Search;
Search.API_URL = "/search/suggest.json";

// src/shared/ProductSearch.ts
var _a, _b, _c;
var _ProductSearch = class {
  static search(handle) {
    return __async(this, null, function* () {
      return fetch(`${_ProductSearch.baseUrl}products/${handle}.js`).then((response) => response.json());
    });
  }
};
var ProductSearch = _ProductSearch;
ProductSearch.baseUrl = `${(_c = (_b = (_a = window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root) != null ? _c : ""}`;

// src/sections/common-cart-drawer/common-cart-drawer.ts
var import_printd = __toESM(require_printd());
var CommonCartDrawer = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.isOpen = false;
    this.isBuyByIdOpen = false;
    this.flipping = new import_flipping.default({ parent: this, duration: 1e3, easing: "ease" });
    this.debouncedPrint = () => {
    };
  }
  computedStyleToInlineStyle(element, options) {
    if (!element) {
      throw new Error("No element specified.");
    }
    if (options == null ? void 0 : options.recursive) {
      Array.prototype.forEach.call(element.children, (child) => {
        this.computedStyleToInlineStyle(child, options);
      });
    }
    const computedStyle = getComputedStyle(element);
    Array.prototype.forEach.call((options == null ? void 0 : options.properties) || computedStyle, (property) => {
      element.style[property] = computedStyle.getPropertyValue(property);
    });
  }
  connectedCallback() {
    return __async(this, null, function* () {
      var _a2, _b2, _c2, _d, _e, _f;
      this.buyByIdErrorText = this.buyByIdError.innerText;
      window.addEventListener("popstate", (event) => {
        if (this.isOpen) {
          this.close();
        }
      });
      const hash = window.location.hash;
      if (hash.startsWith("#cart-")) {
        this.open();
        yield fetch(`${location.origin}${(_c2 = (_b2 = (_a2 = window.Shopify) == null ? void 0 : _a2.routes) == null ? void 0 : _b2.root) != null ? _c2 : ""}${(_f = (_e = (_d = window.Shopify) == null ? void 0 : _d.routes) == null ? void 0 : _e.locale) != null ? _f : ""}/cart/clear.js`);
        const base64 = hash.replace("#cart-", "");
        const json = atob(base64);
        const items = JSON.parse(json);
        yield Theme.Cart.addItem(...items);
        Theme.Cart.emit("updated");
      }
      this.debouncedPrint = Debounce.debounce(() => {
        this.print();
      }, 300);
    });
  }
  print() {
    return __async(this, null, function* () {
      const clonedNode = this.lineItemsWrapper.cloneNode(true);
      clonedNode.style.display = "none";
      clonedNode.id = "print-clone";
      clonedNode.querySelectorAll("[data-cart-quantity-plus]").forEach((elm) => {
        elm.remove();
      });
      clonedNode.querySelectorAll("[data-cart-quantity-minus]").forEach((elm) => {
        elm.remove();
      });
      clonedNode.querySelectorAll("[data-remove]").forEach((elm) => {
        elm.remove();
      });
      clonedNode.querySelectorAll("[data-cart-quantity]").forEach((elm) => {
        elm.outerHTML = "St\xFCckzahl: " + elm.getAttribute("value");
      });
      const totalPriceDiv = document.createElement("div");
      totalPriceDiv.innerHTML = this.cartTotalElm.innerHTML;
      totalPriceDiv.textContent = "Gesammt: " + totalPriceDiv.innerText;
      totalPriceDiv.style.textAlign = "right";
      totalPriceDiv.style.marginTop = "1rem";
      totalPriceDiv.style.marginBottom = "1rem";
      clonedNode.appendChild(totalPriceDiv);
      document.body.appendChild(clonedNode);
      yield requestAnimationFrame(() => {
      });
      this.computedStyleToInlineStyle(clonedNode, { recursive: true });
      const d = new import_printd.Printd();
      const style = `
      #print-clone {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: block !important;
        z-index: 9999;
      }

      #print-clone common-line-item {
        padding-top: 15px;
      }
    `;
      d.print(clonedNode, [style]);
    });
  }
  renderAjaxCart() {
    return __async(this, null, function* () {
      const [html, cartTotal] = yield Promise.all([
        SectionRenderer.renderSection("ajax-cart"),
        SectionRenderer.renderSection("ajax-cart-total")
      ]);
      this.flipping.read();
      this.lineItemsWrapper.innerHTML = html;
      this.cartTotalElm.innerHTML = cartTotal;
      this.flipping.flip();
    });
  }
  increaseBuyByIdQuantity() {
    var _a2, _b2;
    const quantity = parseInt((_b2 = (_a2 = this.buyByIdQuantity) == null ? void 0 : _a2.value) != null ? _b2 : "0");
    this.buyByIdQuantity.value = (quantity + 1).toString();
  }
  decreaseBuyByIdQuantity() {
    var _a2, _b2;
    const quantity = parseInt((_b2 = (_a2 = this.buyByIdQuantity) == null ? void 0 : _a2.value) != null ? _b2 : "0");
    if (quantity > 1) {
      this.buyByIdQuantity.value = (quantity - 1).toString();
    } else {
      this.buyByIdQuantity.value = 1 .toString();
    }
  }
  searchByManufacturerNumber(manufacturerNumber) {
    var _a2, _b2, _c2;
    return fetch(`${(_c2 = (_b2 = (_a2 = window == null ? void 0 : window.Shopify) == null ? void 0 : _a2.routes) == null ? void 0 : _b2.root) != null ? _c2 : "/"}collections/all?filter.v.m.custom.manufacturer_number=${encodeURIComponent(manufacturerNumber)}&section_id=ajax-search-metafield`);
  }
  handleBuyByIdFormSubmit(elm, event, barcodeOnly = false) {
    return __async(this, null, function* () {
      var _a2, _b2, _c2, _d, _e;
      this.buyByIdError.classList.add("hidden");
      if ((_a2 = this.buyByIdVariant) == null ? void 0 : _a2.value) {
        let variant = null;
        let manufacturerNrResponse = null;
        let searchResponse = null;
        const products = [];
        if (barcodeOnly) {
          searchResponse = yield Search.search(this.buyByIdVariant.value, { type: "product", fields: ["variants.barcode"], limit: 1, limitScope: "each", unavailableProducts: "hide" });
        } else {
          [manufacturerNrResponse, searchResponse] = yield Promise.all([
            this.searchByManufacturerNumber(this.buyByIdVariant.value),
            Search.search(this.buyByIdVariant.value, { type: "product", fields: ["variants.sku", "variants.barcode"], limit: 1, limitScope: "each", unavailableProducts: "hide" })
          ]);
        }
        if (manufacturerNrResponse && manufacturerNrResponse.status === 200) {
          const manufacturerNrResponseData = yield manufacturerNrResponse.text();
          const tempEle = document.createElement("div");
          tempEle.innerHTML = manufacturerNrResponseData;
          if (tempEle.innerText.trim() !== "") {
            const variants = JSON.parse(tempEle.innerText);
            if (variants.length > 0) {
              variant = variants.find((v) => v[0] == this.buyByIdVariant.value)[1];
            }
          }
        }
        if (searchResponse && searchResponse.resources.results.products.length > 0) {
          products.push(...searchResponse.resources.results.products);
        }
        if (variant === null && products.length > 0) {
          const results = yield Promise.all(products.map((p) => {
            return ProductSearch.search(p.handle);
          }));
          variant = results.reduce((acc, product) => {
            if (acc) {
              return acc;
            }
            const variant2 = product.variants.find((v) => {
              var _a3, _b3;
              return v.sku === ((_a3 = this.buyByIdVariant) == null ? void 0 : _a3.value) || v.barcode === ((_b3 = this.buyByIdVariant) == null ? void 0 : _b3.value);
            });
            if (variant2) {
              return variant2;
            }
            return acc;
          }, null);
        }
        if (variant) {
          (_b2 = this.buyByIdAddBtn) == null ? void 0 : _b2.setAttribute("loading", "");
          const error = yield Theme.Cart.addItem({ id: variant.id, quantity: parseInt((_d = (_c2 = this.buyByIdQuantity) == null ? void 0 : _c2.value) != null ? _d : "1") });
          if (error) {
            this.buyByIdError.innerText = error.description;
            this.buyByIdError.classList.remove("hidden");
          }
          Theme.Cart.emit("updated");
          (_e = this.buyByIdAddBtn) == null ? void 0 : _e.removeAttribute("loading");
        } else {
          this.buyByIdError.innerText = this.buyByIdErrorText;
          this.buyByIdError.classList.remove("hidden");
        }
      }
    });
  }
  handleBuyByIdQuantityChange() {
    var _a2, _b2;
    const quantity = parseInt((_b2 = (_a2 = this.buyByIdQuantity) == null ? void 0 : _a2.value) != null ? _b2 : "0");
    if (quantity > 1) {
      this.buyByIdQuantity.value = (quantity - 1).toString();
    } else {
      this.buyByIdQuantity.value = 1 .toString();
    }
  }
  handlePrint() {
    this.debouncedPrint();
  }
  handleShare() {
    return __async(this, null, function* () {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h;
      const cart = yield Theme.Cart.fetch();
      const _this = this;
      let timeout = null;
      function close() {
        var _a3, _b3;
        if (timeout) {
          clearTimeout(timeout);
        }
        (_a3 = _this.sharePopover.querySelector("[data-no-products]")) == null ? void 0 : _a3.classList.add("hidden");
        (_b3 = _this.sharePopover.querySelector("[data-copied]")) == null ? void 0 : _b3.classList.add("hidden");
        _this.sharePopover.close();
        _this.removeEventListener("click", close);
      }
      if (!cart.items || cart.items.length === 0) {
        this.sharePopover.open();
        (_a2 = this.sharePopover.querySelector("[data-no-products]")) == null ? void 0 : _a2.classList.remove("hidden");
        timeout = setTimeout(() => {
          close();
        }, 2e3);
        this.addEventListener("click", close);
        return;
      }
      const items = cart.items.map((item) => {
        return { id: item.id, quantity: item.quantity };
      });
      const json = JSON.stringify(items);
      const base64 = btoa(json);
      try {
        yield navigator.share({
          text: "Warenkorb",
          url: `${(_d = (_c2 = (_b2 = window.Shopify) == null ? void 0 : _b2.routes) == null ? void 0 : _c2.root) != null ? _d : window.location.origin}#cart-${base64}`,
          title: "Warenkorb"
        });
      } catch (e) {
        yield navigator.clipboard.writeText(`${(_g = (_f = (_e = window.Shopify) == null ? void 0 : _e.routes) == null ? void 0 : _f.root) != null ? _g : window.location.origin}#cart-${base64}`);
        this.sharePopover.open();
        (_h = this.sharePopover.querySelector("[data-copied]")) == null ? void 0 : _h.classList.remove("hidden");
        timeout = setTimeout(() => {
          close();
        }, 2e3);
        this.addEventListener("click", close);
      }
    });
  }
  loadQuagga() {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.addEventListener("load", () => {
        resolve(true);
      });
      script.addEventListener("error", () => {
        reject("Failed to load Barcode reader");
      });
      script.src = "https://cdn.jsdelivr.net/npm/@ericblade/quagga2/dist/quagga.min.js";
      this.appendChild(script);
    });
  }
  handleBarcode() {
    return __async(this, null, function* () {
      if (!window.Quagga)
        yield this.loadQuagga();
      this.buyByBarcodeError.classList.add("hidden");
      this.barcodeScanner.classList.remove("hidden");
      this.drawer.classList.add("hidden");
      this.buyByIdError.classList.add("hidden");
      const fileinput = this.querySelector("#qr-input-file");
      fileinput.addEventListener("change", (e) => __async(this, null, function* () {
        const target = e.target;
        if (target.files && target.files.length == 0) {
          return;
        }
        const file = target.files[0];
        const FR = new FileReader();
        FR.addEventListener("load", (evt) => {
          Quagga.decodeSingle({
            decoder: {
              readers: [
                "ean_reader",
                "ean_8_reader",
                "code_128_reader",
                "code_39_reader",
                "code_39_vin_reader",
                "codabar_reader",
                "upc_reader",
                "upc_e_reader",
                "i2of5_reader"
              ]
            },
            debug: false,
            locate: true,
            src: evt.target.result
          }, (result) => {
            if (!result || !result.codeResult) {
              this.toggleButton();
              this.buyByBarcodeError.classList.remove("hidden");
              this.buyByIdError.innerText = "";
              this.buyByIdError.classList.add("hidden");
              return;
            }
            this.toggleButton();
            this.buyByIdVariant.value = result.codeResult.code;
            this.handleBuyByIdFormSubmit(null, new Event("click"), true);
            this.closeBarcode();
          });
        });
        FR.readAsDataURL(file);
      }));
    });
  }
  closeBarcode() {
    return __async(this, null, function* () {
      this.barcodeScanner.classList.add("hidden");
      this.drawer.classList.remove("hidden");
    });
  }
  open() {
    return __async(this, null, function* () {
      var _a2;
      if (!this.isOpen) {
        window.history.pushState("cart", "", "#cart");
      }
      this.isOpen = true;
      this.classList.add("block");
      this.classList.remove("hidden");
      yield wait(5);
      this.backdrop.classList.add("opacity-100");
      this.backdrop.classList.remove("opacity-0");
      this.drawer.classList.add("translate-x-0");
      this.drawer.classList.remove("translate-x-[calc(100%+5rem)]");
      (_a2 = document.querySelector("#trustbadge-container-98e3dadd90eb493088abdc5597a70810")) == null ? void 0 : _a2.classList.add("!opacity-0");
    });
  }
  close() {
    return __async(this, null, function* () {
      var _a2;
      this.isOpen = false;
      this.backdrop.classList.add("opacity-0");
      this.backdrop.classList.remove("opacity-100");
      this.drawer.classList.add("translate-x-[calc(100%+5rem)]");
      this.drawer.classList.remove("translate-x-0");
      yield wait(700);
      if (!this.isOpen) {
        this.classList.add("hidden");
        this.classList.remove("block");
      }
      (_a2 = document.querySelector("#trustbadge-container-98e3dadd90eb493088abdc5597a70810")) == null ? void 0 : _a2.classList.remove("!opacity-0");
    });
  }
  handleUpdateCart() {
    this.renderAjaxCart();
  }
  startLoading() {
    this.checkoutBtn.setAttribute("loading", "");
  }
  stopLoading() {
    this.checkoutBtn.removeAttribute("loading");
  }
  toggleButton() {
    if (this.isBuyByIdOpen) {
      this.closeToast();
    } else {
      this.openToast();
    }
  }
  openToast() {
    return __async(this, null, function* () {
      var _a2, _b2;
      this.isBuyByIdOpen = true;
      (_a2 = this.chevron) == null ? void 0 : _a2.classList.add("rotate-180");
      (_b2 = this.buyByIdAccordion) == null ? void 0 : _b2.open();
    });
  }
  closeToast() {
    return __async(this, null, function* () {
      var _a2, _b2;
      this.isBuyByIdOpen = false;
      (_a2 = this.chevron) == null ? void 0 : _a2.classList.remove("rotate-180");
      (_b2 = this.buyByIdAccordion) == null ? void 0 : _b2.close();
    });
  }
};
__decorateClass([
  query("[data-chevron]")
], CommonCartDrawer.prototype, "chevron", 2);
__decorateClass([
  query("[data-buy-by-id-accordion]")
], CommonCartDrawer.prototype, "buyByIdAccordion", 2);
__decorateClass([
  query("[data-buy-by-id-quantity]")
], CommonCartDrawer.prototype, "buyByIdQuantity", 2);
__decorateClass([
  query("[data-buy-by-id-variant]")
], CommonCartDrawer.prototype, "buyByIdVariant", 2);
__decorateClass([
  query("[data-buy-by-id-form]")
], CommonCartDrawer.prototype, "buyByIdForm", 2);
__decorateClass([
  query("[data-buy-by-id-add]")
], CommonCartDrawer.prototype, "buyByIdAddBtn", 2);
__decorateClass([
  liquidValue("routes.cart_add_url")
], CommonCartDrawer.prototype, "cartUrl", 2);
__decorateClass([
  query("[data-backdrop]")
], CommonCartDrawer.prototype, "backdrop", 2);
__decorateClass([
  query("[data-drawer]")
], CommonCartDrawer.prototype, "drawer", 2);
__decorateClass([
  query("[data-line-items]")
], CommonCartDrawer.prototype, "lineItemsWrapper", 2);
__decorateClass([
  query("[data-cart-total]")
], CommonCartDrawer.prototype, "cartTotalElm", 2);
__decorateClass([
  query("[data-checkout]")
], CommonCartDrawer.prototype, "checkoutBtn", 2);
__decorateClass([
  query("[data-buy-by-id-error]")
], CommonCartDrawer.prototype, "buyByIdError", 2);
__decorateClass([
  query("[data-buy-by-barcode-error]")
], CommonCartDrawer.prototype, "buyByBarcodeError", 2);
__decorateClass([
  query("[data-barcode-scanner]")
], CommonCartDrawer.prototype, "barcodeScanner", 2);
__decorateClass([
  query("[data-share-popover]")
], CommonCartDrawer.prototype, "sharePopover", 2);
__decorateClass([
  onClick("[data-buy-by-id-quantity-plus]")
], CommonCartDrawer.prototype, "increaseBuyByIdQuantity", 1);
__decorateClass([
  onClick("[data-buy-by-id-quantity-minus]")
], CommonCartDrawer.prototype, "decreaseBuyByIdQuantity", 1);
__decorateClass([
  on("click", "[data-buy-by-id-add]")
], CommonCartDrawer.prototype, "handleBuyByIdFormSubmit", 1);
__decorateClass([
  on("change", "[data-buy-by-id-quantity]")
], CommonCartDrawer.prototype, "handleBuyByIdQuantityChange", 1);
__decorateClass([
  on("click", "[data-print]")
], CommonCartDrawer.prototype, "handlePrint", 1);
__decorateClass([
  on("click", "[data-share]")
], CommonCartDrawer.prototype, "handleShare", 1);
__decorateClass([
  on("click", "[data-barcode]")
], CommonCartDrawer.prototype, "handleBarcode", 1);
__decorateClass([
  on("click", "[data-close-barcode]")
], CommonCartDrawer.prototype, "closeBarcode", 1);
__decorateClass([
  globalOn("cart:open")
], CommonCartDrawer.prototype, "open", 1);
__decorateClass([
  globalOn("cart:close"),
  onClick("[data-close], [data-backdrop]")
], CommonCartDrawer.prototype, "close", 1);
__decorateClass([
  globalOn("cart:updated")
], CommonCartDrawer.prototype, "handleUpdateCart", 1);
__decorateClass([
  onClick("[data-checkout]"),
  globalOn("cart:startLoading")
], CommonCartDrawer.prototype, "startLoading", 1);
__decorateClass([
  globalOn("cart:stopLoading")
], CommonCartDrawer.prototype, "stopLoading", 1);
__decorateClass([
  onClick("[data-buy-by-id-btn]")
], CommonCartDrawer.prototype, "toggleButton", 1);
CommonCartDrawer = __decorateClass([
  defineElement("common-cart-drawer")
], CommonCartDrawer);
export {
  CommonCartDrawer
};
/*! Bundled license information:

rematrix/dist/rematrix.js:
  (*  @license Rematrix v0.1.3
  
      Copyright (c) 2017 Fisssion LLC
  
      Permission is hereby granted, free of charge, to any person obtaining a copy
      of this software and associated documentation files (the "Software"), to deal
      in the Software without restriction, including without limitation the rights
      to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the Software is
      furnished to do so, subject to the following conditions:
  
      The above copyright notice and this permission notice shall be included in
      all copies or substantial portions of the Software.
  
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      THE SOFTWARE.
  *)
*/
